import { useContext } from "react";
import moment from "moment";
import { useHistory } from "react-router-dom";

import {
  CLI_TOKEN_PARAM,
  LS_CLI_TOKEN,
  LS_CLI_TOKEN_SUCCESS_PARAM,
  LS_CLI_USED,
} from "@constants";
import { OrgContext, UserContext } from "@providers";
import {
  getCLILoginToken,
  recoverBrowserSecurityError,
  withToaster,
} from "@utils";

import { createTokenRequest } from "@pages/settings/api";

export const didUserUseCliLogin = () => {
  const cliLoginUsedOn = recoverBrowserSecurityError(() =>
    localStorage.getItem(LS_CLI_USED)
  );
  return (
    !!cliLoginUsedOn &&
    moment().diff(moment(parseInt(cliLoginUsedOn)), "hours") <= 36
  );
};

export function useCLIToken() {
  const history = useHistory();
  const { user } = useContext(UserContext);
  const { org } = useContext(OrgContext);
  const cliToken = getCLILoginToken();

  const createToken = async () => {
    if (!cliToken || !user || !org) return false;
    const isCreated = await withToaster(
      async () => {
        await createTokenRequest(org.id, cliToken);
        recoverBrowserSecurityError(() => {
          localStorage.removeItem(LS_CLI_TOKEN);
          localStorage.setItem(LS_CLI_USED, new Date().getTime().toString());
        });

        let cleanURL = new URL(window.location.href);
        cleanURL.searchParams.delete(CLI_TOKEN_PARAM);
        cleanURL.searchParams.append(LS_CLI_TOKEN_SUCCESS_PARAM, "true");
        history.replace(cleanURL.pathname + cleanURL.search);

        return true;
      },
      async (err) => {
        if (err.statusCode === 409) {
          // CONFLICT: the token already exists in the DB - problem!
          recoverBrowserSecurityError(() => {
            localStorage.removeItem(LS_CLI_TOKEN);
          });
          let cleanURL = new URL(window.location.href);
          history.replace(cleanURL.pathname);
          return "Error in token: Please retry the whole process, or try an alternative login method.";
        }
        return `Error creating token: ${err.message}`;
      }
    )();
    return isCreated;
  };
  return { createToken };
}
